var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('Loader'):_vm._e(),_c('router-view'),_c('DocumentComplianceModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }